import * as React from 'react';
import CountryService from '../../services/CountryService';

interface IWeightDisplayProps {
  weight: number;
}

export const WeightDisplay = (props: IWeightDisplayProps) => {
  const { weight } = props;
  const { country } = CountryService.GetInstance();

  const value = country.weightUnit === 'lb'
    ? weight * 2.20462262
    : weight;

  return (
    <React.Fragment>
      {Math.round((value / 1000) * 100) / 100} {country.weightUnit || 'kg'}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/WeightDisplay/WeightDisplay.tsx